import { render, staticRenderFns } from "./order-summary.vue?vue&type=template&id=042b4eb6&scoped=true&"
import script from "./order-summary.component.ts?vue&type=script&lang=ts&"
export * from "./order-summary.component.ts?vue&type=script&lang=ts&"
import style0 from "./order-summary.scss?vue&type=style&index=0&id=042b4eb6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "042b4eb6",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/mnt/www/planning-web-v2/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('042b4eb6')) {
      api.createRecord('042b4eb6', component.options)
    } else {
      api.reload('042b4eb6', component.options)
    }
    module.hot.accept("./order-summary.vue?vue&type=template&id=042b4eb6&scoped=true&", function () {
      api.rerender('042b4eb6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/last-mile-delivery-wellcome/components/order-summary/order-summary.vue"
export default component.exports